import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Tabs, Tab } from '@pocketlaw/tetris';
import { TabsContainer, StyledTabContent, StyledTabNav } from './styled';
import { EsignFormTabs } from './types';
export function SidebarTabs(props) {
    const { recipients, settings, activity } = props;
    const [activeTab, setActiveTab] = useState(EsignFormTabs.Recipients);
    const handleSelectTab = (tab) => {
        setActiveTab(tab);
    };
    return (<TabsContainer>
      <Tabs activeTab={activeTab} onSelect={handleSelectTab}>
        <StyledTabNav>
          <Tab id={EsignFormTabs.Recipients}>
            <Trans comment="Label for e-signing parties tab">Parties</Trans>
          </Tab>
          {settings && (<Tab id={EsignFormTabs.Settings}>
              <Trans comment="Label for e-signing settings tab">Settings</Trans>
            </Tab>)}
          <Tab id={EsignFormTabs.Activity}>
            <Trans comment="Label for e-signing activity tab">Activity</Trans>
          </Tab>
        </StyledTabNav>
        <StyledTabContent tabId={EsignFormTabs.Recipients}>{recipients}</StyledTabContent>
        <StyledTabContent tabId={EsignFormTabs.Settings}>{settings}</StyledTabContent>
        <StyledTabContent tabId={EsignFormTabs.Activity}>{activity}</StyledTabContent>
      </Tabs>
    </TabsContainer>);
}
